<div *ngIf="!isCommission" class="version-indicator" (click)="dialogService.openChangelog()">
  {{ version }}
</div>
